var map = {
	"./amazon_logo.svg": 5344,
	"./arrow.svg": 581,
	"./at.svg": 290,
	"./bg/dark/download.svg": 7776,
	"./bg/dark/pattern.svg": 9994,
	"./bg/light/download.svg": 9703,
	"./bg/light/pattern.svg": 933,
	"./bg/plan_advanced.svg": 5740,
	"./bg/plan_pro.svg": 3699,
	"./bg/plan_start.svg": 7036,
	"./dark/activity history.svg": 5538,
	"./dark/arrow_down.svg": 9478,
	"./dark/cart.svg": 8373,
	"./dark/copy.svg": 4114,
	"./dark/dashboard.svg": 5884,
	"./dark/dislike.svg": 7961,
	"./dark/edit.svg": 8065,
	"./dark/favorite deals.svg": 9160,
	"./dark/get plan.svg": 9477,
	"./dark/grid.svg": 6833,
	"./dark/heart.svg": 9741,
	"./dark/heart_filled.svg": 7993,
	"./dark/like.svg": 3573,
	"./dark/lngSwitchWhite.svg": 8854,
	"./dark/my deals.svg": 4314,
	"./dark/notification.svg": 7614,
	"./dark/notification_off.svg": 1039,
	"./dark/profile.svg": 5376,
	"./dark/row.svg": 8429,
	"./dark/settings.svg": 9900,
	"./dark/star.svg": 5201,
	"./dark/star_filled.svg": 2816,
	"./dark/telegram.svg": 8685,
	"./google.svg": 3530,
	"./light/activity history.svg": 7161,
	"./light/arrow-down.svg": 2093,
	"./light/cart.svg": 9915,
	"./light/copy.svg": 3942,
	"./light/dashboard.svg": 201,
	"./light/dislike.svg": 5180,
	"./light/edit.svg": 9272,
	"./light/favorite deals.svg": 5927,
	"./light/get plan.svg": 7289,
	"./light/grid.svg": 1511,
	"./light/heart.svg": 4012,
	"./light/heart_filled.svg": 881,
	"./light/like.svg": 7065,
	"./light/lngSwitchGray.svg": 8553,
	"./light/my deals.svg": 5753,
	"./light/notification.svg": 3268,
	"./light/notification_off.svg": 4659,
	"./light/profile.svg": 3037,
	"./light/row.svg": 9403,
	"./light/settings.svg": 9027,
	"./light/star.svg": 8575,
	"./light/star_filled.svg": 3755,
	"./light/telegram.svg": 8525,
	"./loading.svg": 7791,
	"./lock.svg": 8619,
	"./moon.svg": 3108,
	"./plan_advanced.svg": 9818,
	"./plan_pro.svg": 9394,
	"./plan_start.svg": 5934,
	"./plus.svg": 5467,
	"./question.svg": 1709,
	"./spinner.svg": 2273,
	"./sun.svg": 3146,
	"./user.svg": 1494,
	"./wave.svg": 1726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9173;